export interface ParsedError {
  status: number | string;
  message: string;
  stack: string[] | null;
  debugInfo: any;
}

export function parseErrors(error: any): ParsedError[] {
  const newErrors: ParsedError[] = [];
  if (error.networkError) {
    // Apollo network error
    if (error.networkError.result.errors) {
      error.networkError.result.errors.forEach((error: any) => {
        newErrors.push({
          message: error.message,
          debugInfo: {},
          stack: error.extensions.stacktrace,
          status: error.extensions.code
        });
      });
    } else {
      newErrors.push({
        message: error.networkError.result.error,
        debugInfo: {},
        stack: error.networkError.result.error.stacktrace,
        status: error.networkError.statusCode
      });
    }
  }
  else if (error.graphQLErrors) {
    // Apollo graphql error
    error.graphQLErrors.forEach((error: any) => {
      newErrors.push({
        message: error.message,
        debugInfo: error.extensions,
        stack: error.extensions.stacktrace,
        status: error.extensions.code
      });
    });
  }
  else if (error.data && error.status) {
    newErrors.push({
      message: error.message,
      debugInfo: error.data,
      stack: null,
      status: error.status
    });
  }
  else {
    // Unknown error
    newErrors.push({
      message: error.message,
      debugInfo: {},
      stack: error.stack ? error.stack.split('\n') : [],
      status: error.status || 'unknown'
    });
  }

  return newErrors;
}

export function runQuery(query: any) {
  return query.then((data: any) => {
    if (data.error) {
      throw data.error;
    }
    return data;
  })
}